import React, { Component } from "react";
import { s3Upload } from "../activities/uploader/s3-uploader";
import PdfThumbnail from "../pdfViewer/PdfThumbnail";
import PdfPlaceholder from "../pdfViewer/PdfPlaceholder";
import "./MultiLangPdfUpload.css";

class MultiLangPdfUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      languagesPDF: props.initialLanguagesPDF || {},
      loadingLangs: {},
    };

    this.getPlaceHolderPDF = this.getPlaceHolderPDF.bind(this);
    this.onPDFOpen = this.onPDFOpen.bind(this);
  }

  // ✅ Sync prop changes to state when parent updates selected language(s)
  componentDidUpdate(prevProps) {
    if (prevProps.initialLanguagesPDF !== this.props.initialLanguagesPDF) {
      this.setState({ languagesPDF: this.props.initialLanguagesPDF || {} });
    }
  }

  getPlaceHolderPDF(langId = "EN") {
    if (this.state.loadingLangs[langId]) return;

    const inputElement = document.createElement("input");
    inputElement.type = "file";
    inputElement.accept = "application/pdf";
    inputElement.multiple = false;

    inputElement.dispatchEvent(new MouseEvent("click"));
    inputElement.addEventListener("change", () => this.onPDFOpen(inputElement, langId));
  }

  async onPDFOpen(inputElement, langId) {
    const file = inputElement.files[0];
    if (!file) return;

    this.setState(prev => ({
      loadingLangs: { ...prev.loadingLangs, [langId]: true },
    }));

    try {
      const uploaded = await s3Upload(file, "froalaUploads");

      const languagesPDF = {
        ...this.state.languagesPDF,
        [langId]: { url: uploaded.Location, name: file.name },
      };

      this.setState(prev => ({
        languagesPDF,
        loadingLangs: { ...prev.loadingLangs, [langId]: false },
      }));

      if (this.props.onChange) {
        this.props.onChange(languagesPDF);
      }
    } catch (err) {
      console.error("Upload failed:", err);
      this.setState(prev => ({
        loadingLangs: { ...prev.loadingLangs, [langId]: false },
      }));
    }
  }

  render() {
    const languages = this.props.languages || [{ id: "en", name: "English" }];
    const { loadingLangs } = this.state;

    const langHTML = languages.map(lang => {
      const langId = lang.id.toUpperCase();
      const pdfData = this.state.languagesPDF[langId];
      const isLoading = loadingLangs[langId];

      return (
        <div
          key={langId}
          className={`PDFimage ${isLoading ? "disabled" : ""}`}
          onClick={() => !isLoading && this.getPlaceHolderPDF(langId)}
        >
          {pdfData && pdfData.url ? (
            <PdfThumbnail
              url={pdfData.url}
              name={pdfData.name}
              scale={0.3}
              language={lang.name || "English"}
              onRemove={() => {
                if (isLoading) return;
                const languagesPDF = { ...this.state.languagesPDF };
                delete languagesPDF[langId];
                this.setState({ languagesPDF });
              }}
            />
          ) : (
            <div className="pdf-upload-wrapper">
              <PdfPlaceholder language={lang.name || "English"} />
              {isLoading && <div className="pdf-upload-loading">Uploading...</div>}
            </div>
          )}
        </div>
      );
    });

    return <div className="multiLanguagePDFUploadContainer">{langHTML}</div>;
  }
}

export default MultiLangPdfUpload;
